import {
  Label,
  Input,
  RecordInterface,
} from '@components/common/Forms';
import { SetMirrorData } from '@type/job-add';

/** Props */
interface JobOwnApplyUrlProps {
  record: RecordInterface,
  inputName?: string,
  label?: string,
  labelHelper?: string,
  labelDescriptionClass?: string,
  setMirrorData?: SetMirrorData,
}

/**
 * @description Job own apply component. To be used in a form.
 * - `record` - record function from useBjForm
 * - `inputName` - name of the input; default is 'ownApplyUrl'
 * - `label` - label for the input
 * - `labelHelper` - label helper for the input
 * - `labelDescriptionClass` - additional classes for the label description
 * - `setMirrorData` - function to update the mirror form state
 */
export const JobOwnApplyUrl = (props: JobOwnApplyUrlProps) => {
  // Destructure props
  const {
    record,
    inputName = 'ownApplyUrl',
    label = '',
    labelHelper = '',
    labelDescriptionClass = '',
    setMirrorData,
  } = props;

  // Render
  // **************************
  return (
    <Label
      description={label}
      descriptionHelper={labelHelper}
      descriptionClass={labelDescriptionClass}
    >
      <Input
        type="text"
        onBlur={() => setMirrorData?.()}
        {...record(inputName)}
      />
    </Label>
  );
};
